"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InputBase_1 = __importDefault(require("@mui/material/InputBase"));
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
require("../assets/styles/mobilesearch.css");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
function SearchBar() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(""), inputValue = _a[0], setInputValue = _a[1];
    function handleChange(event) {
        setInputValue(event.target.value);
    }
    function handleSubmit(event) {
        event.preventDefault();
        console.log("Input value:", inputValue);
        var seacrhurlform = inputValue.split(" ").join("+");
        navigate("/result?searchproduct=".concat(seacrhurlform));
    }
    return (react_1.default.createElement("form", { className: "mobilesearch", onSubmit: handleSubmit },
        react_1.default.createElement(Search_1.default, null),
        react_1.default.createElement("div", { className: "textdiv" },
            react_1.default.createElement(InputBase_1.default, { id: "searchinput", fullWidth: true, placeholder: "search........", onChange: handleChange })),
        react_1.default.createElement(material_1.Button, { size: "small", variant: "contained", sx: { borderRadius: "0 20px 20px 0", height: "32px", fontSize: "15" }, color: "primary", className: "search_button", type: "submit" }, "search")));
}
exports.default = SearchBar;
